import { routeNames, routePaths } from '@/router/router-constants'
import type { RouteRecordRaw } from 'vue-router'

export const practiceRoutes: RouteRecordRaw[] = [
  {
    path: routePaths.practices,
    name: routeNames.practices,
    component: () => import('@/pages/practices/PracticesView.vue'),
    meta: {
      icon: 'material-symbols-outlined',
      iconText: 'home_storage',
      permission: 'practices.read.assigned',
      labelKey: 'practices',
    },
  },
  {
    path: routePaths.practiceDetailsRedirecter,
    name: routeNames.practiceDetailsRedirecter,
    component: () => import('@/pages/practices/details/PracticeDetailsRedirecterView.vue'),
    meta: {
      permission: 'practices.read.assigned',
      labelKey: 'practices',
    },
  },
  {
    path: routePaths.practiceWithCaseCreation,
    name: routeNames.practiceWithCaseCreation,
    component: () => import('@/pages/practices/creation/AddCaseView.vue'),
    meta: {
      labelKey: 'new_f',
      permission: 'cases.write.all',
      rootRouteName: routeNames.practices,
    },
  },
  {
    path: routePaths.practiceCreation,
    name: routeNames.practiceCreation,
    component: () => import('@/pages/practices/creation/AddPracticeView.vue'),
    meta: {
      labelKey: 'new_f',
      permission: 'practices.write.all',
      rootRouteName: routeNames.practices,
    },
  },
  {
    path: routePaths.practiceDetails,
    component: () => import('@/pages/practices/details/PracticeDetailsView.vue'),
    meta: {
      permission: 'practices.read.assigned',
      rootRouteName: routeNames.practices,
    },
    children: [
      {
        path: routePaths.practiceDetails,
        component: () => import('@/pages/practices/details/PracticeDetailsTabs.vue'),
        meta: {
          permission: 'practices.read.assigned',
        },
        children: [
          {
            path: routePaths.practiceDetails,
            name: routeNames.practiceDetails,
            component: () => import('@/pages/practices/details/tabs/practiceDetailsTab/PracticeDetailsTab.vue'),
          },
          {
            path: routePaths.practiceDetailsRecords,
            name: routeNames.practiceDetailsRecords,
            component: () => import('@/pages/practices/details/tabs/recordsTab/PracticeRecordsTab.vue'),
            meta: {
              labelKey: 'practiceDetailsRecords',
              featureFlag: 'records',
            },
          },
          {
            path: routePaths.practiceDetailsEvents,
            name: routeNames.practiceDetailsEvents,
            component: () => import('@/pages/practices/details/tabs/practiceEventsTab/PracticeEventsTab.vue'),
            meta: {
              labelKey: 'practiceDetailsEvents',
            },
          },
          {
            path: routePaths.practiceDetailsSubjects,
            name: routeNames.practiceDetailsSubjects,
            component: () => import('@/pages/practices/details/tabs/practiceSubjectsTab/PracticeSubjectsTab.vue'),
            meta: {
              labelKey: 'practiceDetailsSubjects',
              permission: 'subjects.read.assigned',
            },
          },
          {
            path: routePaths.practiceDetailsSubjectDetails,
            name: routeNames.practiceDetailsSubjectDetails,
            component: () => import('@/pages/practices/details/tabs/practiceSubjectsTab/PracticeSubjectDetailsTab.vue'),
            meta: {
              permission: 'subjects.read.assigned',
              labelKey: 'practiceDetailsSubjects',
            },
          },
          {
            path: routePaths.practiceDetailsSubjectRecords,
            name: routeNames.practiceDetailsSubjectRecords,
            redirect: ({ params }) => ({ name: routeNames.practiceDetailsSubjectDetails, params }),
            meta: {
              labelKey: 'practiceDetailsSubjectRecords',
              permission: 'subjects.read.assigned',
              featureFlag: 'records',
            },
          },
          {
            path: routePaths.practiceDetailsDeadlines,
            name: routeNames.practiceDetailsDeadlines,
            redirect: ({ params }) => ({ name: routeNames.practiceDetails, params }),
            meta: {
              labelKey: 'practiceDetailsDeadlines',
              permission: 'practices.read.assigned',
              featureFlag: 'deadlines',
            },
          },
          {
            path: routePaths.practiceDetailsDeadlineDetails,
            name: routeNames.practiceDetailsDeadlineDetails,
            component: () => import('@/pages/practices/details/tabs/deadlineDetailsTab/DeadlineDetailsTab.vue'),
            meta: {
              labelKey: 'practiceDetailsDeadlines',
              permission: 'deadlines.read.assigned',
              featureFlag: 'deadlines',
            },
          },
          {
            path: routePaths.practiceDetailsPctEvents,
            name: routeNames.practiceDetailsPctEvents,
            component: () => import('@/pages/practices/details/tabs/pctEventsTab/PctEventsTab.vue'),
            meta: {
              labelKey: 'practiceDetailsPctEvents',
              permission: 'pct.read.all',
              featureFlag: 'pct',
            },
          },
          {
            path: routePaths.practiceDetailsPctSubjects,
            name: routeNames.practiceDetailsPctSubjects,
            redirect: () => ({ name: routeNames.practiceDetailsPctEvents }),
            meta: {
              labelKey: 'practiceDetailsPctSubjects',
              permission: 'pct.read.all',
              featureFlag: 'pct',
            },
          },
          {
            path: routePaths.practiceDetailsPctSubjectsImport,
            name: routeNames.practiceDetailsPctSubjectsImport,
            component: () => import('@/pages/practices/details/tabs/pctSubjectsImportTab/PctSubjectsImportTab.vue'),
            meta: {
              labelKey: 'practiceDetailsPctSubjectsImport',
              permission: 'subjects.write.assigned',
              featureFlag: 'pct',
            },
          },
          {
            path: routePaths.practiceDetailsTasks,
            name: routeNames.practiceDetailsTasks,
            component: () => import('@/pages/practices/details/tabs/tasksTab/TasksTab.vue'),
            meta: {
              labelKey: 'tasks',
              permission: 'tasks.read.assigned',
              featureFlag: 'tasks',
            },
          },
          {
            path: routePaths.practiceDetailsTaskDetails,
            name: routeNames.practiceDetailsTaskDetails,
            component: () => import('@/pages/practices/details/tabs/tasksTab/TaskDetailsTab.vue'),
            meta: {
              labelKey: 'tasks',
              permission: 'tasks.read.assigned',
              featureFlag: 'tasks',
            },
          },
        ],
      },
    ],
  },
  {
    path: routePaths.practiceEdit,
    component: () => import('@/pages/practices/edit/EditPracticeView.vue'),
    meta: {
      permission: 'practices.write.assigned',
      rootRouteName: routeNames.practices,
    },
    children: [
      {
        path: '',
        name: routeNames.practiceEdit,
        component: () => import('@/pages/practices/edit/EditPracticeData.vue'),
        meta: {
          labelKey: 'edit',
        },
      },
      {
        path: routePaths.practiceEditRelations,
        name: routeNames.practiceEditRelations,
        component: () => import('@/pages/practices/edit/EditPracticeRelations.vue'),
        meta: {
          labelKey: 'relations',
          permission: 'cases.write.all',
        },
      },
      {
        path: routePaths.practiceEditCase,
        name: routeNames.practiceEditCase,
        component: () => import('@/pages/practices/edit/EditPracticeCase.vue'),
        meta: {
          labelKey: 'case',
          permission: 'cases.write.all',
        },
      },
    ],
  },
  {
    path: routePaths.practiceDetailsRecordCreation,
    name: routeNames.practiceDetailsRecordCreation,
    component: () => import('@/pages/practices/record-creation/AddPracticeRecordView.vue'),
    meta: {
      labelKey: 'new_f',
      permission: 'practices.write.assigned',
      rootRouteName: routeNames.practices,
      featureFlag: 'records',
    },
  },
  {
    path: routePaths.practiceSubjectCreation,
    name: routeNames.practiceSubjectCreation,
    component: () => import('@/pages/subjects/add/AddSubjectView.vue'),
    meta: {
      labelKey: 'new_m',
      permission: 'subjects.write.assigned',
      rootRouteName: routeNames.practices,
    },
  },
  {
    path: routePaths.practiceDetailsSubjectRecordCreation,
    name: routeNames.practiceDetailsSubjectRecordCreation,
    component: () => import('@/pages/subjects/record-creation/AddSubjectRecordView.vue'),
    meta: {
      labelKey: 'new_f',
      permission: 'subjects.write.assigned',
      rootRouteName: routeNames.practices,
      featureFlag: 'records',
    },
  },
  {
    path: routePaths.deadlineCreation,
    name: routeNames.deadlineCreation,
    component: () => import('@/pages/deadlines/AddDeadlineView.vue'),
    meta: {
      labelKey: 'new_f',
      permission: 'deadlines.write.all',
      rootRouteName: routeNames.practices,
      featureFlag: 'deadlines',
    },
  },
  {
    path: routePaths.deadlineEdit,
    name: routeNames.deadlineEdit,
    component: () => import('@/pages/deadlines/EditDeadlineView.vue'),
    meta: {
      labelKey: 'edit',
      permission: 'deadlines.write.all',
      rootRouteName: routeNames.practices,
      featureFlag: 'deadlines',
    },
  },
]
